import { Marker } from 'react-map-gl';

type StartMarkerProps = {
  latitude: number;
  longitude: number;
};

export default function StartMarker({ latitude, longitude }: StartMarkerProps) {
  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      anchor="bottom"
      style={{
        height: '1.5rem',
        width: '1.5rem'
      }}
    >
      <div
        style={{
          height: '1.5rem',
          width: '1.5rem',
          border: '0.2rem solid white',
          borderRadius: '50%',
          backgroundColor: '#36ca43'
        }}
      />
    </Marker>
  );
}
